export const getTransferWorkOrderList = state => {
    return state.list
}

export const getTransferWorkOrderDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/transferWorkOrder/getters.js